import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import './assets/css/login_form.scss'


import store from './store'
import { uuid } from '@/utils/util'
store.dispatch('setUuid', uuid())


import toast from './utils/toast'
Vue.use(toast)

import modelMask from '@/components/modelMask.vue'
Vue.component("modelMask",modelMask)
// import { Swiper } from "vue-awesome-swiper";
// import 'swiper/dist/css/swiper.css'
// Vue.use(Swiper)

import animated from "animate.css";
Vue.use(animated)

// 金额保留2位小数
function numFormat(num) {
	if (typeof num === 'number') {
		return Math.round(num * 100)/100
	} else {
		return ''
	}
}
let fnObj = {
  numFormat,
}
Object.assign(Vue.prototype, fnObj);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
